import { Component, OnInit, EventEmitter } from '@angular/core';
import { APP_SETTINGS } from 'src/environments/environment';
import { SpvService } from 'src/app/services/spv.service';
import { PTService } from '../pt/pt.service';
import { OSService } from 'src/app/services/os-service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  heading = APP_SETTINGS.nomeCliente;
  subheading = 'Sistema de Controle Automático de Manutenção';
  icon = 'pe-7s-menu icon-gradient bg-premium-dark';

  public tipoInstalacao: string = '';
  public nomeCliente: string = '';

  constructor() {
    this.tipoInstalacao = APP_SETTINGS.tipoInstalacao;
    this.nomeCliente = APP_SETTINGS.nomeCliente;
  }

  ngOnInit() {
  }

}
